module.exports = __webpack_public_path__ + "img/Jingkuan_Song@2x.40a2a06d.png";